import { useState } from 'react';
import { CalendarDays, Loader2, Save } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Carte, Champ, MODES_CP, TitreCarte } from './constantes';

const CHAMPS = ['date', 'heure_debut', 'heure_fin', 'mode', 'lieu', 'lien_visio', 'president_nom', 'president_fonction'];

export const OngletSeance = ({ cp }) => {
  const { conseil, enregistrer } = cp;
  const [f, setF] = useState(() => Object.fromEntries(CHAMPS.map((k) => [k, conseil[k] || ''])));
  const [envoi, setEnvoi] = useState(false);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const sauver = async () => {
    setEnvoi(true);
    await enregistrer({ ...f, mode: f.mode || 'presentiel' }, 'Séance enregistrée');
    setEnvoi(false);
  };

  return (
    <Carte data-testid="cp-seance">
      <TitreCarte Icone={CalendarDays} titre="La séance" sousTitre="Ces informations figurent sur les convocations, la feuille d'émargement et le procès-verbal." />
      <div className="grid gap-5 sm:grid-cols-3">
        <Champ label="Date"><Input type="date" value={f.date} onChange={set('date')} data-testid="cp-date" /></Champ>
        <Champ label="Début"><Input type="time" value={f.heure_debut} onChange={set('heure_debut')} data-testid="cp-heure-debut" /></Champ>
        <Champ label="Fin"><Input type="time" value={f.heure_fin} onChange={set('heure_fin')} data-testid="cp-heure-fin" /></Champ>
      </div>
      <Champ label="Modalité" className="mt-6">
        <div className="inline-flex flex-wrap gap-1 rounded-full bg-slate-100 p-1">
          {Object.entries(MODES_CP).map(([k, l]) => (
            <button key={k} type="button" onClick={() => setF((x) => ({ ...x, mode: k }))} data-testid={`cp-mode-${k}`}
              className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors duration-200 ${(f.mode || 'presentiel') === k ? 'bg-[#0F172A] text-white' : 'text-slate-600 hover:bg-white'}`}>{l}</button>
          ))}
        </div>
      </Champ>
      <div className="mt-6 grid gap-5 sm:grid-cols-2">
        {f.mode !== 'visio' && <Champ label="Lieu"><Input value={f.lieu} onChange={set('lieu')} placeholder="Ex : salle de cours FISL" data-testid="cp-lieu" /></Champ>}
        {f.mode && f.mode !== 'presentiel' && (
          <Champ label="Lien de visioconférence"><Input value={f.lien_visio} onChange={set('lien_visio')} placeholder="https://meet.google.com/…" data-testid="cp-lien-visio" /></Champ>
        )}
        <Champ label="Président de séance"><Input value={f.president_nom} onChange={set('president_nom')} placeholder="Prénom Nom" data-testid="cp-president-nom" /></Champ>
        <Champ label="Fonction"><Input value={f.president_fonction} onChange={set('president_fonction')} data-testid="cp-president-fonction" /></Champ>
      </div>
      <Button onClick={sauver} disabled={envoi} className="mt-8 rounded-full bg-[#0F172A] px-6" data-testid="cp-seance-enregistrer">
        {envoi ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />} Enregistrer
      </Button>
    </Carte>
  );
};
